import { debounce } from 'lodash'

export type FormBehaviorTriggerSource = 'init' | 'change' | 'hydrate'

export type FormBehaviorEvaluator = (
  source: FormBehaviorTriggerSource,
  changedKeyName?: string
) => void

const evaluators = new Map<string, FormBehaviorEvaluator>()

export const registerFormBehaviorEvaluator = (
  layoutUid: string,
  evaluate: FormBehaviorEvaluator
): void => {
  evaluators.set(layoutUid, evaluate)
}

export const unregisterFormBehaviorEvaluator = (layoutUid: string): void => {
  evaluators.delete(layoutUid)
}

export const triggerFormBehaviorEvaluation = debounce(
  (
    layoutUid: string,
    source: FormBehaviorTriggerSource,
    changedKeyName?: string
  ): void => {
    const evaluate = evaluators.get(layoutUid)
    if (!evaluate) return
    evaluate(source, changedKeyName)
  },
  500
)
